<template>
    <modal @close="editPromotionCancelClick" class="edit-modal" hideFooter id="edit-promotion">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Edit Promotion</h3>
                    <div v-if="isCsrOrAdmin() === false" class="mt-5">
                        <h3>Stand Out In The Crowd</h3>
                        <p>
                            Run a promotion targeting customers actively looking for your services. Whenever a customer runs a search that displays your business, your TruckDown Promotion will be presented at the top of the results.
                        </p>
                        <h3>Rise Above The Competition</h3>
                        <p>
                            When your TruckDown Promotion is displayed, it will be the only one shown. By linking directly to your business, your customers see and can act on your offer immediately. No bidding to get shown first - if there is more than one promotion running in any area, they are rotated one at a time.
                        </p>
                    </div>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Edit Promotion</h3>
                    <div class="md-col-2">
                        <div class="column">
                            <div>
                                <label class="td-label td-text-bold mt-0">Title:</label>
                                <input v-model="promotionToEdit.title" type="text" placeholder="" :class="{'error': promotionValidator.errors['title']}"
                                       @input="promotionValidator.validate('title')" />
                                <error v-if="promotionValidator.errors['title']" :error="promotionValidator.errors['title']"></error>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold">Message:</label>
                                <textarea rows="6" v-model="promotionToEdit.message" type="text" placeholder="" :class="{'error': promotionValidator.errors['message']}"
                                          @input="promotionValidator.validate('message')" />
                                <error v-if="promotionValidator.errors['message']" :error="promotionValidator.errors['message']"></error>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold">
                                    All Locations
                                    <input name="allLocations" type="checkbox" v-model="promotionToEdit.applyToAllLocations" :checked="promotionToEdit.applyToAllLocations" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-5" v-if="!promotionToEdit.applyToAllLocations">
                                <label for="location" class="td-label mt-2 td-text-bold">Select Location:</label>
                                <location-lookup :hide-label="true"
                                                 :account-id="promotion.accountId"
                                                 :is-error="promotionValidator.errors['locationIds'] && promotionValidator.errors['locationIds'].length > 0"
                                                 :selected-locations="selectedLocations"
                                                 @select-location="selectLocation">
                                </location-lookup>
                                <error v-if="promotionValidator.errors['locationIds']" :error="promotionValidator.errors['locationIds']"></error>
                            </div>
                        </div>
                        <div class="column">
                            <div>
                                <label class="td-label td-text-bold">Expiry Date:</label>
                                <input v-model="expiryDateInput" type="date" placeholder="" :class="{'error': promotionValidator.errors['expiryDate']}"
                                       @input="promotionValidator.validate('expiryDate')" @change="expiryChange" />
                                <error v-if="promotionValidator.errors['expiryDate']" :error="promotionValidator.errors['expiryDate']"></error>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold">
                                    No Expiry Date
                                    <input name="noExpiryDate" type="checkbox" v-model="noExpiryDate" :checked="noExpiryDate === true" @change="noExpiryChange" />
                                    <span></span>
                                </label>
                            </div>

                            <div v-if="!promotionToEdit.applyToAllLocations" class="mt-3">
                                <label class="td-label td-text-bold">Selected Location(s):</label>
                                <div v-for="location in locationList" class="td-card shadow rounded my-1">
                                    <p class="ma-1">{{ location.display }}  <a href="#" @click.prevent="removeLocation(location)">remove</a></p>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>

                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="editPromotionCancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="editPromotionSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditPromotion';
    export default script;
</script>
<style lang="less">
    @import './EditPromotion.less';
</style>